"use client"

import { Tabs, TabPane } from '@douyinfe/semi-ui';
import './feature-tabs.css';
import { IAgentView, IAgentDemoVO } from '@/types';
import { motion } from 'framer-motion';
import { useState } from 'react';

export default function AgentTabs({ data }: { data: IAgentView[] }) {
  const [activeTab, setActiveTab] = useState(0);

  function handleItemClick(item: IAgentDemoVO) {
    if (item.path) {
      return window.open(item.path, '_blank')
    }

    if (item.agentType == 4) {
      window.open('/chat/oral-reading?agentId=' + item.agentId, '_blank');
    } else {
      if (item.agentType == 5) {
        window.open('/chat/modify?agentId=' + item.agentId, '_blank')
        return;
      }
      window.open('/chat/?agentId=' + item.agentId, '_blank')
    }
  }

  function tabComponent(tab: string, content: string, index: number, isActive: boolean): React.ReactNode {
    return (
      <>
        <div className='cursor-pointer tab-item-s relative z-10'>
          <div className='text-lg font-bold text-[#1765FF]'>{tab}</div>
          <div className='text-sm text-[#1765FF]/70 pr-[90px] font-normal'>{content}</div>
        </div>
        {isActive && (
          <motion.img
            key={index}
            src={`/images/student/left-${index + 1}.png`}
            className='tab-bg absolute right-4 bottom-0 w-[130px] h-[144px]'
            initial={{ y: 0, opacity: 0 }}
            animate={{ opacity: 1, y: -5 }}
            exit={{ y: 0, opacity: 0 }}
            transition={{
              duration: 0,
              velocity: 2,
            }}
          />
        )}
      </>
    )
  }


  function handleDemoClick(item: IAgentDemoVO) {
    if (item.path) {
      return window.open(item.path, '_blank')
    }

    if (!item.agentId) return;

    if (item.enableFlag) {

      if (item.agentType === 5) {
        window.open('/chat/share/report?id=68cbaa2094f7b90acc0baab8', '_blank')
        return;
      }

      window.open('/chat/chat-view?viewId=' + item.detailId + '&agentId=' + item.agentId, '_blank')
    } else {
      if (item.agentType == 4) {
        return;
      }
      window.open('/chat/?agentId=' + item.agentId, '_blank')
    }
  }

  function tabPaneAgentComponent(data: IAgentDemoVO[]): React.ReactNode {
    return (
      <>
        {data?.map((item: IAgentDemoVO, index: number) => (
          <div key={index} className='relative bg-[#F5F7FA] rounded-2xl w-full max-w-[430px] h-[256px] p-4 flex items-center justify-between cursor-pointer' onClick={() => handleItemClick(item)}>
            <div className='flex flex-col self-stretch justify-around'>
              <div className="lg:mt-2 relative h-full flex flex-col">
                <div className='font-bold text-[#303133] text-lg mb-1'>{item.agentName}</div>
                <div className='text-[#606266] text-sm'>{item.description}</div>
                {
                  item.enableFlag && (
                    <div className=' text-sm w-[112px] h-[40px] font-bold bg-[#E4E7ED] text-[#303133] rounded-full  items-center justify-center hidden lg:flex  cursor-pointer mt-auto flex-shrink-0' onClick={(e) => {
                      e.stopPropagation()
                      handleDemoClick(item)
                    }}>
                      <span className='font_family icon-Play text-2xl! text-[#303133] mr-1'></span>
                      效果演示
                    </div>
                  )
                }
              </div>
            </div>

            <div className='border border-[#E4E7ED] rounded-lg flex-shrink-0'>
              <img className='w-[128px] h-[180px] rounded-lg' src={item.cover}></img>
            </div>
          </div>
        ))}
      </>
    )
  }

  return (
    <>
      <div className='mx-auto max-w-[1140px] hidden lg:block'>
        <Tabs
          tabPosition='left'
          className='feature-tabs-s'
          type='button'
          activeKey={activeTab.toString()}
          onChange={key => setActiveTab(Number(key))}
        >
          {
            data?.map((item: IAgentView, index: number) => (
              <TabPane
                key={index}
                itemKey={index.toString()}
                tab={tabComponent(item.name, item.description, index, activeTab === index)}
              >
                {tabPaneAgentComponent(item.wkAgentDemoVOS)}
              </TabPane>
            ))
          }
        </Tabs>
      </div>

      <div className="lg:hidden block">
        <div className="w-full pb-20">
          {
            data?.map((item: IAgentView, index: number) => (
              <div key={index} className='gap-4 flex flex-col items-center justify-center mt-10'>
                <div className='flex flex-col items-center justify-center'>
                  <div className='text-lg font-bold text-[#303133]'>{item.name}</div>
                  <div className='text-sm text-[#606266]'>{item.description}</div>
                </div>
                <div className='flex flex-wrap gap-4 items-center justify-center'>
                  {tabPaneAgentComponent(item.wkAgentDemoVOS)}
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </>

  )
}
